module.exports = __webpack_public_path__ + "img/title5.2b0cf59d.png";